import { IconCheck } from '@tabler/icons-react'
import type { JSX, ReactNode } from 'react'

export function ComboboxOption({
  children,
  isSelected,
}: {
  children: ReactNode
  isSelected?: boolean
}): JSX.Element {
  return (
    <div className="flex flex-1 items-center justify-between">
      <div className="flex items-center gap-2">{children}</div>
      {isSelected && <IconCheck className="mr-0.5 size-4 shrink-0" />}
    </div>
  )
}
